import { render, staticRenderFns } from "./AdPersonaIcon.vue?vue&type=template&id=65a48004&scoped=true"
import script from "./AdPersonaIcon.vue?vue&type=script&lang=js"
export * from "./AdPersonaIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a48004",
  null
  
)

export default component.exports